module.exports = __webpack_public_path__ + "static/media/bank-stars-bg.ce2a65a2.png";